module.exports = __webpack_public_path__ + "static/media/client.9c1769cd.jpg";